//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ChangelogMixin from "@Broker/@Modules/clients/board/client-profile/mixins/changelog-mixin.js";
import BoardChangelogCollapse from "./board-changelog-collapse.vue";
import BoardChangelogTooltip from "./board-changelog-tooltip.vue";
import { Fragment } from "vue-fragment";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChangelogList",
  components: {
    BoardChangelogCollapse,
    BoardChangelogTooltip,
    Fragment
  },
  mixins: [ChangelogMixin],
  props: {
    changelogList: {
      type: [Object, Array],
      required: true
    },
    userDetails: {
      type: Object,
      default: () => ({})
    },
    boardId: {
      type: [String, Number],
      default: ""
    },
    origin: {
      type: String,
      default: "boards"
    },
    tooltipTrigger: {
      type: String,
      default: "click blur"
    }
  },
  methods: {
    isLast(index) {
      return index + 1 === this.changelogList.length;
    }
  }
});